import React from "react";
import { injectIntl, defineMessages } from "react-intl";
import compose from "recompose/compose";
import useShouldDisplayCommandStatusTimeout from "./useShouldDisplayCommandStatusTimeout";
import EnhanceAddProductToWishlist from "./EnhanceAddProductToWishlist";
import IconButton from "theme/components/atoms/Button/IconButton";

const messages = defineMessages({
  addToWishlist: {
    id: "modules.Wishlist.AddProductToWishlist.addToWishlist",
    defaultMessage: "Add to wishlist",
  },
  removeFromWishlist: {
    id: "modules.Wishlist.AddProductToWishlist.removeFromWishlist",
    defaultMessage: "Remove from wishlist",
  },
});

const AddProductToWishlist = (props) => {
  const shouldDisplayCommandStatus = useShouldDisplayCommandStatusTimeout(
    // Keep this value bigger than the timeout in
    // src/web/theme/modules/ProductView/ProductItem/ProductItemActions/ProductItemActions.js
    // to avoid blinking effect
    2500,
    props.commandResponse,
    props.commandPending
  );

  return (
    <>
      {props.loginModal}
      <IconButton
        state={props.commandPending ? "pending" : null}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          typeof props.onAddStart === "function" && props.onAddStart();
          props
            .ensureLoggedIn()
            .then(() => {
              props.toggleProductInWishlist();
            })
            .catch((e) => {
              typeof props.onAddDone === "function" && props.onAddDone();
            });
        }}
        appearance={props.isInWishlist ? "block-primary" : "block"}
        icon={
          shouldDisplayCommandStatus && props.commandResponse
            ? props.commandResponse.success
              ? "checkmark"
              : "cross"
            : "heart"
        }
        size={props.size}
        title={
          props.isInWishlist
            ? props.intl.formatMessage(messages.removeFromWishlist)
            : props.intl.formatMessage(messages.addToWishlist)
        }
      />
    </>
  );
};

export default compose(
  EnhanceAddProductToWishlist(),
  injectIntl
)(AddProductToWishlist);
